/**
 * Tree zoom state and controls
 */

import { useState, useCallback } from 'react';
import { ZOOM_CONFIG } from '../constants';

export function useTreeZoom() {
  const [zoomLevel, setZoomLevel] = useState<number>(ZOOM_CONFIG.default);

  const zoomIn = useCallback(() => {
    setZoomLevel(prev => Math.min(prev + ZOOM_CONFIG.step, ZOOM_CONFIG.max));
  }, []);

  const zoomOut = useCallback(() => {
    setZoomLevel(prev => Math.max(prev - ZOOM_CONFIG.step, ZOOM_CONFIG.min));
  }, []);

  const resetZoom = useCallback(() => {
    setZoomLevel(ZOOM_CONFIG.default);
  }, []);

  return {
    zoomLevel,
    zoomIn,
    zoomOut,
    resetZoom,
    canZoomIn: zoomLevel < ZOOM_CONFIG.max,
    canZoomOut: zoomLevel > ZOOM_CONFIG.min
  };
}
